import { Api } from 'utils';

class OrderService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/orders/',params),
		view: async (params?: any) => Api.createResponse('admin/orders/view',params),
		download: async (params?: any) => Api.createResponse('admin/orders/download',params),
		changePaymentStatus: async (params?: any) => Api.createResponse('admin/orders/change-payment-status',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/orders/change-status',params),
	}

}

export default OrderService;